import { render, staticRenderFns } from "./Lightbulb.vue?vue&type=template&id=908681ae&scoped=true&"
import script from "./Lightbulb.vue?vue&type=script&lang=js&"
export * from "./Lightbulb.vue?vue&type=script&lang=js&"
import style0 from "./Lightbulb.vue?vue&type=style&index=0&id=908681ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908681ae",
  null
  
)

export default component.exports